import styles from "./Toast.module.css";
import classNames from "classnames/bind";
import { SizeOfElement } from "../../utils";
import imageDemo from "../../assets/images/Avatar.png";
import { iconClose, iconError, iconInfo, iconSuccess } from "../Icons/IconToast";

const cx = classNames.bind(styles)

const Toast = {
  async open(element, type) {
    //Tạo element chứa các notification
    let ele = document.getElementById("__notification");
    //Tạo một thẻ div
    let div = document.createElement("div");
    // Tạo một thẻ imgType
    let spanType = document.createElement("span");
    // Tạo thẻ div content 
    let divContent = document.createElement('div');
    // Tạo một thẻ close icon
    let spanClose = document.createElement('span');
    //Kiểm tra nếu đã có một thẻ div khác tồn tại
    if (ele.childNodes.length === 1) {
      if (!ele.childNodes[0].getAttribute("data-close"))
        //Thay đổi style của thẻ div cũ
        ele.childNodes[0].className = cx(
          "container", "open-notification", "open-notification-two"
        );
    }
    //Kiểm tra nếu đã có một thẻ div khác tồn tại
    if (ele.childNodes.length === 2) {
      if (!ele.childNodes[0].getAttribute("data-close")) {
        //Thay đổi style của thẻ div cũ
        ele.childNodes[0].className = cx(
          "container", "open-notification", "open-notification-three"
        );
      }
      if (!ele.childNodes[1].getAttribute("data-close")) {
        //Thay đổi style của thẻ div cũ
        ele.childNodes[1].className = cx(
          "container", "open-notification", "open-notification-two"
        );
      }
    }
    //Thêm style vào thẻ div mới
    div.className = cx(
      "container", "open-notification", "open-notification-one"
    );
    // Thêm nội dung cho thẻ span type
    if (type === "success") {
      spanType.innerHTML = iconSuccess;
    }
    if (type === "danger") {
      spanType.innerHTML = iconError;
    }
    if (type === 'info') {
      spanType.innerHTML = iconInfo;
    }
    //Thêm string element vào thẻ divContent
    divContent.innerHTML = element;
    // Thêm class cho thẻ span close
    spanClose.className = cx("close-button")
    // Thêm nội dung cho thẻ span close
    spanClose.innerHTML = iconClose;
    //Zindex để nổi lên trên bề mặt
    div.style.zIndex = 100000000;
    // Thêm nội dung vào thẻ div
    div.appendChild(spanType);
    div.appendChild(divContent);
    div.appendChild(spanClose);
    //Add sự kiện khi người dùng hover vào thẻ div
    div.onmouseenter = () => {
      //Delay remove thẻ div
      div.setAttribute("data-delay", "true");
    };
    div.onmouseleave = () => {
      //Tạo lại sự kiện xóa thẻ div
      div.setAttribute("data-delay", "false");
      div.setAttribute("data-close", "true");
      setTimeout(() => {
        if (div.getAttribute("data-delay") === "false") {
          let { elementBottom } = SizeOfElement(div);
          if (elementBottom === 160) {
            div.className = cx(
              "container", "close-notification", "close-notification-three"
            );
          } else if (elementBottom === 95) {
            div.className = cx(
              "container", "close-notification", "close-notification-two"
            );
          } else {
            div.className = cx(
              "container", "close-notification", "close-notification-one"
            );
          }
          div.setAttribute("data-close", "true");
        }
      }, 2000);

      setTimeout(() => {
        if (
          !div.getAttribute("data-delay") ||
          (div.getAttribute("data-delay") === "false" && ele.contains(div))
        )
          ele.removeChild(div);
      }, 3000);
    };
    // Thêm thẻ div vào element notification
    ele.appendChild(div);
    // Settimeout ẩn thẻ div đi dần
    setTimeout(() => {
      if (
        !div.getAttribute("data-delay") ||
        div.getAttribute("data-delay") === "false"
      ) {
        let { elementBottom } = SizeOfElement(div);
        if (elementBottom === 160) {
          div.className = cx(
            "container", "close-notification", "close-notification-three"
          );
        } else if (elementBottom === 95) {
          div.className = cx(
            "container", "close-notification", "close-notification-two"
          );
        } else {
          div.className = cx(
            "container", "close-notification", "close-notification-one"
          );
        }
        div.setAttribute("data-close", "true");
      }
    }, 3000);
    //Xóa thẻ div khỏi element notification
    setTimeout(() => {
      if (
        (!div.getAttribute("data-delay") ||
          div.getAttribute("data-delay") === "false") &&
        div.getAttribute("data-close") &&
        ele.contains(div)
      )
        ele.removeChild(div);
    }, 4000);
    // Xóa thẻ div khi click span close
    spanClose.onclick = () => {
      ele.removeChild(div)
    };
  },
  async tooltip() { },
  async notification(header, body, image) {
    //Tạo element chứa các notification
    let ele = document.getElementById("__notification");
    //Màu styles
    //Tạo một thẻ div
    let div = document.createElement("div");
    // Tạo một thẻ img
    let img = document.createElement("img");
    //Tạo một thẻ div content of notification
    let divContent = document.createElement("div");
    // Tạo một thẻ h1
    let h1 = document.createElement("h1");
    // Tạo một thẻ p
    let p = document.createElement("p");
    //Kiểm tra nếu đã có một thẻ div khác tồn tại
    if (ele.childNodes.length === 1) {
      if (!ele.childNodes[0].getAttribute("data-close"))
        //Thay đổi style của thẻ div cũ
        ele.childNodes[0].className = cx(
          "container", "open-notification", "open-notification-two"
        );
    }
    //Kiểm tra nếu đã có một thẻ div khác tồn tại
    if (ele.childNodes.length === 2) {
      if (!ele.childNodes[0].getAttribute("data-close")) {
        //Thay đổi style của thẻ div cũ
        ele.childNodes[0].className = cx(
          "container", "open-notification", "open-notification-three"
        );
      }
      if (!ele.childNodes[1].getAttribute("data-close")) {
        //Thay đổi style của thẻ div cũ
        ele.childNodes[1].className = cx(
          "container", "open-notification", "open-notification-two"
        );
      }
    }
    //Thêm style vào thẻ div mới
    div.className = cx(
      "container", "open-notification", "open-notification-one"
    );
    div.style.background = "white";
    div.style.color = "#333";
    div.style.display = "flex";
    //Zindex để nổi lên trên bề mặt
    div.style.zIndex = 100000000;
    // Thêm class  cho thẻ img 
    img.className = cx(
      "image-notification"
    );
    img.alt = 'avatar-user';
    img.src = image ? image : imageDemo;
    // Thêm class  cho thẻ divContent
    divContent.className = cx(
      "content-notification"
    );
    // Thêm class + content cho thẻ h1
    h1.className = cx(
      "header-notification"
    );
    h1.innerText = header;
    // Thêm class + content cho thẻ p
    p.className = cx(
      "body-notification"
    );
    p.innerText = body;
    //  Thêm thẻ element h1 + p vào thẻ divContent
    divContent.appendChild(h1)
    divContent.appendChild(p)
    //Thêm thẻ element con vào thẻ div
    div.appendChild(img);
    div.appendChild(divContent);
    // Add sự kiện khi người dùng hover vào thẻ div
    div.onmouseenter = () => {
      //Delay remove thẻ div
      div.setAttribute("data-delay", "true");
    };
    div.onmouseleave = () => {
      //Tạo lại sự kiện xóa thẻ div
      div.setAttribute("data-delay", "false");
      div.setAttribute("data-close", "true");
      setTimeout(() => {
        if (div.getAttribute("data-delay") === "false") {
          let { elementBottom } = SizeOfElement(div);
          if (elementBottom === 160) {
            div.className = cx(
              "container", "close-notification", "close-notification-three"
            );
          } else if (elementBottom === 95) {
            div.className = cx(
              "container", "close-notification", "close-notification-two"
            );
          } else {
            div.className = cx(
              "container", "close-notification", "close-notification-one"
            );
          }
          div.setAttribute("data-close", "true");
        }
      }, 2000);

      setTimeout(() => {
        if (
          !div.getAttribute("data-delay") ||
          (div.getAttribute("data-delay") === "false" && ele.contains(div))
        )
          ele.removeChild(div);
      }, 3000);
    };
    // Thêm thẻ div vào element notification
    ele.appendChild(div);
    // Settimeout ẩn thẻ div đi dần
    setTimeout(() => {
      if (
        !div.getAttribute("data-delay") ||
        div.getAttribute("data-delay") === "false"
      ) {
        let { elementBottom } = SizeOfElement(div);
        if (elementBottom === 160) {
          div.className = cx(
            "container", "close-notification", "close-notification-three"
          );
        } else if (elementBottom === 95) {
          div.className = cx(
            "container", "close-notification", "close-notification-two"
          );
        } else {
          div.className = cx(
            "container", "close-notification", "close-notification-one"
          );
        }
        div.setAttribute("data-close", "true");
      }
    }, 3000);
    // Xóa thẻ div khỏi element notification
    setTimeout(() => {
      if (
        (!div.getAttribute("data-delay") ||
          div.getAttribute("data-delay") === "false") &&
        div.getAttribute("data-close") &&
        ele.contains(div)
      )
        ele.removeChild(div);
    }, 4000);
  }
};

export default Toast;
